<template>
    <div class="w-full flex flex-col">
        
        <span class="text-sm text-gray-500">Step {{ currentStep }} of {{ totalSteps }}</span>

        <typography variant="h4" class="text-gray-900 dark:text-gray-100">
            <slot name="header"/>
        </typography>

        <typography variant="p" class="text-gray-600 mt-2">
            <slot name="description"/>
        </typography>

    </div>
</template>

<script>
export default {
    name: "OnboardingHeader",
    props: {
        currentStep: {
            type: Number,
            required: true
        },
        totalSteps: {
            type: Number,
            required: true
        }
    }
}
</script>